import React from "react";
import {
  StyleSheet,
  Text,
  View,
  Modal,
  TouchableOpacity,
  ActivityIndicator,
} from "react-native";
import Colours from "../utils/Colours";
import QuestionMark from "../icons/QuestionMark";

const NoticeAlertComp = ({
  message,
  onClose,
  onCancel,
  isLoading,
  fromTransfer,
}) => {
  return (
    <View style={styles.modalOverlay}>
      <View style={styles.modalContainer}>
        <QuestionMark height={40} width={40} color={"red"} />
        {/* <CrossIcon height={40} width={40} color={'red'} /> */}
        <Text style={styles.noticeTitle}>Notice!</Text>
        <Text style={styles.noticeMessage}>{message}</Text>

        {/* Button Container */}
        <View style={styles.buttonContainer}>
          <TouchableOpacity
            style={styles.closeButton}
            onPress={onClose}
            disabled={isLoading}
          >
            {isLoading ? (
              <ActivityIndicator size="small" color="#fff" />
            ) : (
              <Text style={styles.closeButtonText}>
                {fromTransfer ? "Seen" : "Proceed"}
              </Text>
            )}
          </TouchableOpacity>
          <TouchableOpacity style={styles.cancelButton} onPress={onCancel}>
            <Text style={styles.closeButtonText}>
              {fromTransfer ? "Noted" : "Cancel"}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

export default NoticeAlertComp;

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalContainer: {
    width: "80%",
    padding: 20,
    backgroundColor: "white",
    borderRadius: 10,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  noticeTitle: {
    fontSize: 20,
    fontWeight: "bold",
    color: Colours.PRIMARY,
    marginBottom: 10,
    fontFamily: "Sen-Regular",
  },
  noticeMessage: {
    fontSize: 16,
    color: "#333",
    textAlign: "center",
    justifyContent: "center",
    marginBottom: 20,
    marginTop: 10,
    fontFamily: "Sen-Regular",
    // textAlign: 'justify',
  },
  buttonContainer: {
    flexDirection: "row", // Align buttons horizontally
    justifyContent: "space-between",
    width: "100%", // Make sure the container takes the full width
    marginTop: 10,
  },
  closeButton: {
    backgroundColor: Colours.PRIMARY,
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 10,
    flex: 1, // Make buttons take equal space
    alignItems: "center",
    marginRight: 10, // Add spacing between buttons
  },
  cancelButton: {
    backgroundColor: Colours.DARKLIGHTGRAY, // Use a different color for cancel
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 10,
    flex: 1,
    alignItems: "center",
  },
  closeButtonText: {
    color: "white",
    fontWeight: "bold",
    fontSize: 15,
    fontFamily: "Sen-Regular",
  },
});
